import React, { useReducer, useMemo, useContext } from 'react'
import { Button, Modal, Row, Col } from 'antd'
import { simpleReducer } from '../../../../helper'
import { AppConfig } from '../../../../AppConfig'
import { profileScreen } from '../../../../translates'
import { ConfigContext } from '../../../../context/configContext'
import PhotoViewerRotate from '../PhotoViewerRotate/PhotoViewerRotate'

const initialState = {
  isOpenModal: false
}

function DocumentDoubleView ({ loading, onCommit }) {
  const [state, setState] = useReducer(simpleReducer, initialState)
  const { isCoordinator } = useContext(ConfigContext)

  const handleOpen = () => {
    setState({ isOpenModal: true })
  }
  const handleCancel = () => {
    setState({ isOpenModal: false })
  }

  const documentList = useMemo(() => {
    return AppConfig.documentNameList.filter(d => ![
      profileScreen.input.lmkMainPhoto.name,
      profileScreen.input.lmkAllowancePhoto.name,
      profileScreen.input.lmkAttestationPhoto.name
    ].includes(d) || (
      [
        profileScreen.input.lmkMainPhoto.name,
        profileScreen.input.lmkAllowancePhoto.name,
        profileScreen.input.lmkAttestationPhoto.name
      ].includes(d) && !isCoordinator
    ))
  }, [isCoordinator])

  return (
    <>
      <Button onClick={handleOpen} style={{ marginLeft: '1rem' }} size='small'>Сравнить документы</Button>
      <Modal
        title='Сравнение документов'
        visible={state.isOpenModal}
        width='90%'
        style={{ top: 20, height: '70vh' }}
        footer={null}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Row style={{ height: '80vh' }}>
          <Col span={12}>
            <PhotoViewerRotate
              componentName='first'
              documents={documentList}
              loading={loading}
              onCommitDocument={onCommit}
            />
          </Col>
          <Col span={12}>
            <PhotoViewerRotate
              componentName='second'
              documents={documentList}
              disableApproval
            />
          </Col>
        </Row>
        <div style={{ textAlign: 'right' }}>
          <Button onClick={handleCancel}>Закрыть</Button>
        </div>
      </Modal>
    </>
  )
}

export default DocumentDoubleView
